import _ from 'lodash';

const baseFields = [
  'roleId',
  'firstName',
  'lastName',
  'email',
  'province',
  'contactNumber',
  'salesManager',
  'salesManagerEmail'
];

const adminFields = [
  'roleId',
  'firstName',
  'lastName',
  'email',
  'province',
  'contactNumber',
  'xid',
  'salesManager',
  'salesManagerEmail'
];

const salesRepFields = [
  'roleId',
  'firstName',
  'lastName',
  'email',
  'province',
  'contactNumber',
  'channelId',
  'outlet',
  'cpmsId',
  'salesManager',
  'salesManagerEmail'
];

const salesRepDealerFields = [
  'roleId',
  'firstName',
  'lastName',
  'email',
  'province',
  'contactNumber',
  'channelId',
  'dealership',
  'channelOrgCode',
  'outlet',
  'cpmsId',
  'salesManager',
  'salesManagerEmail'
];

const salesRepCorpStoreFields = [
  'roleId',
  'firstName',
  'lastName',
  'email',
  'province',
  'contactNumber',
  'channelId',
  'storeCode',
  'xid',
  'salesManager',
  'salesManagerEmail'
];

const salesRepXidFields = [
  'roleId',
  'firstName',
  'lastName',
  'email',
  'province',
  'contactNumber',
  'channelId',
  'xid',
  'salesManager',
  'salesManagerEmail'
];

const salesManagerFields = [
  'roleId',
  'firstName',
  'lastName',
  'email',
  'province',
  'contactNumber',
  'channelId',
  'outlet',
  'cpmsId',
  'salesManager',
  'salesManagerEmail'
];

const salesManagerCorpStoreFields = [
  'roleId',
  'firstName',
  'lastName',
  'email',
  'province',
  'contactNumber',
  'channelId',
  'storeCode',
  'xid',
  'salesManager',
  'salesManagerEmail'
];

const salesManagerXidFields = [
  'roleId',
  'firstName',
  'lastName',
  'email',
  'province',
  'contactNumber',
  'channelId',
  'xid',
  'salesManager',
  'salesManagerEmail'
];

const orderFulfillmentFields = [
  'roleId',
  'firstName',
  'lastName',
  'email',
  'province',
  'contactNumber',
  'xid',
  'salesManager',
  'salesManagerEmail'
];

const proposalHouseFields = [
  'roleId',
  'firstName',
  'lastName',
  'email',
  'province',
  'contactNumber',
  'xid',
  'salesManager',
  'salesManagerEmail'
];

const salesSupportFields = [
  'roleId',
  'firstName',
  'lastName',
  'email',
  'provinceIds',
  'contactNumber',
  'channelIds',
  'xid',
  'salesManager',
  'salesManagerEmail'
];

const salesSupportForCorpStore = [
  'roleId',
  'firstName',
  'lastName',
  'email',
  'provinceIds',
  'contactNumber',
  'channelIds',
  'storeCode',
  'xid',
  'salesManager',
  'salesManagerEmail'
];

const salesSupportForDealer = [
  'roleId',
  'firstName',
  'lastName',
  'email',
  'provinceIds',
  'contactNumber',
  'channelIds',
  'dealership',
  'channelOrgCode',
  'xid',
  'salesManager',
  'salesManagerEmail'
];

const salesSupportForCorpStoreAndDealer = [
  'roleId',
  'firstName',
  'lastName',
  'email',
  'provinceIds',
  'contactNumber',
  'channelIds',
  'dealership',
  'channelOrgCode',
  'storeCode',
  'xid',
  'salesManager',
  'salesManagerEmail'
];

const checkFieldToDisplay = (roleId, value) => {
  const valueChannelId =
    roleId === 11
      ? _.get(value, 'channelIds', [])
      : _.get(value, 'channelId.0.id', '');

  switch (roleId) {
    case 1:
      return adminFields;
    case 2:
      if ([7, 89, 90, 91, 92].includes(+valueChannelId))
        return salesRepXidFields;
      if (+valueChannelId === 9) return salesRepDealerFields;
      if (+valueChannelId === 99) return salesRepCorpStoreFields;
      return salesRepFields;
    case 3:
      return orderFulfillmentFields;
    case 6:
      return proposalHouseFields;
    case 7:
      if ([7, 89, 90, 91, 92].includes(+valueChannelId))
        return salesManagerXidFields;
      if (+valueChannelId === 9) return salesRepDealerFields;
      if (+valueChannelId === 99) return salesManagerCorpStoreFields;
      return salesManagerFields;
    case 11:
      if (valueChannelId.includes(9) && !valueChannelId.includes(99))
        return salesSupportForDealer;
      if (!valueChannelId.includes(9) && valueChannelId.includes(99))
        return salesSupportForCorpStore;
      if (valueChannelId.includes(9) && valueChannelId.includes(99))
        return salesSupportForCorpStoreAndDealer;

      return salesSupportFields;
    default:
      return baseFields;
  }
};

export default checkFieldToDisplay;
